module.exports = __webpack_public_path__ + "img/sfmd4.7474222d.jpg";